<div class="chart-card">
  <div class="chart-header">
    <h3 class="chart-title">{{ title }}</h3>
  </div>
  <div class="chart-container">
    <canvas
      baseChart
      [data]="barChartData"
      [options]="barChartOptions"
      [type]="'bar'"
    ></canvas>
  </div>
</div>

